// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Filter types enum.
 */
export enum FilterTypeEnum {
  Expression = 0,
  Keys = 1,
  Named = 2
}
